module.exports = __webpack_public_path__ + "img/cartao_hipercard.c9510f22.png";